import { httpClient } from "../utilities/HttpHelper"
import { apiHost } from "../constants/api"

export const getStationCurrent = async (province, amphoe, tambon) => {
    let q = []
    if(province!==null&&(typeof province!=='undefined')) q.push(`province=${province}`)
    if(amphoe!==null&&(typeof amphoe!=='undefined')) q.push(`amphoe=${amphoe}`)
    if(tambon!==null&&(typeof tambon!=='undefined')) q.push(`tambon=${tambon}`)
    let fetchUrl = `${apiHost}/station/current?${q.join("&")}`
    let response = await httpClient.get(fetchUrl)
    if(response.status === 200) {
        return response.data
    }
    return []
}

export const getStationHistory = async (stn) => {
    let fetchUrl = `${apiHost}/station/history?stn=${stn}`
    let response = await httpClient.get(fetchUrl)
    if(response.status === 200) {
        return response.data
    }
    return []
}